module.exports = __webpack_public_path__ + "img/racecourse-fairview-poly-2200.b733c7bb.svg";